var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0.9
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1,
    x2: 0,
    y1: 0.5,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0.8
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1,
    x2: 0,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0.6
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    x2: 0.5,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0.5
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0.4
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    y1: 0.5,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0.3
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 25,
    x: 43,
    y: 4,
    fill: "url(#a)",
    stroke: "#000",
    ry: 5,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    x: 61.4,
    y: 29.6,
    fill: "url(#b)",
    stroke: "#000",
    ry: 5,
    rx: 5,
    transform: "rotate(-45 61.44 34.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    x: 67,
    y: 43,
    fill: "url(#c)",
    stroke: "#000",
    ry: 5,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    x: 61.4,
    y: 56.4,
    fill: "url(#d)",
    stroke: "#000",
    ry: 5,
    rx: 5,
    transform: "rotate(45 61.44 61.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 25,
    x: 43,
    y: 67,
    fill: "url(#e)",
    stroke: "#000",
    ry: 5,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    x: 9.6,
    y: 56.4,
    fill: "url(#f)",
    stroke: "#000",
    ry: 5,
    rx: 5,
    transform: "rotate(-45 34.56 61.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    x: 4,
    y: 43,
    fill: "url(#g)",
    stroke: "#000",
    ry: 5,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    x: 9.6,
    y: 29.6,
    fill: "url(#h)",
    stroke: "#000",
    ry: 5,
    rx: 5,
    transform: "rotate(45 34.56 34.56)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    fill: "freeze",
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 48 48",
    to: "360 48 48",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWh);
export default __webpack_public_path__ + "static/media/loaderWh.d54a055be5e14c9fe5fa208ea233ba95.svg";
export { ForwardRef as ReactComponent };